import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext.js';

function Footer() {
  const currentYear = new Date().getFullYear();
  const { language, translations } = useContext(LanguageContext);

  return (
    <footer className="footer">
      <p>
        &copy; {currentYear} pufok. {translations[language].footer}
      </p>
    </footer>
  );
}

export default Footer;
